import React from 'react';
import PageTemplate from '../../components/PageTemplate';
const IoTDevelopment = () => {
  return <PageTemplate title="IoT Development" subtitle="Internet of Things Solutions" breadcrumb="Engineering > IoT Development"><div className="content-section"><p>IoT device development, sensor integration, and connected systems.</p></div></PageTemplate>;
};
export default IoTDevelopment; 